import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  section: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },

  sectionInner: {
    width: '100%',

    [theme.fn.largerThan('lg')]: {
      width: 700,
    },
  },

  cardsGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._12,
  },

  card: {
    width: '100%',
    backgroundColor: theme.white,
    borderRadius: theme.other.spacing._16,
    padding: theme.other.spacing._16,
    minHeight: 120,
  },

  skeleton: {
    background: theme.colors.gray2[0],
    backgroundSize: '200% 100%',
    borderRadius: theme.radius.sm,
  },

  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.other.spacing._16,
  },

  dateText: {
    height: 16,
    width: 100,
  },

  marketHeaders: {
    display: 'flex',
    gap: theme.other.spacing._4,
  },

  marketHeader: {
    height: 12,
    width: 60,

    [theme.fn.largerThan('sm')]: {
      width: 100,
    },
  },

  teamsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._12,
  },

  teamRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._12,
  },

  teamLogo: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    flexShrink: 0,
  },

  teamInfo: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._4,
  },

  teamName: {
    height: 16,
    width: 40,

    [theme.fn.largerThan('sm')]: {
      width: 100,
    },
  },

  teamRecord: {
    height: 12,
    width: 30,
  },

  marketCells: {
    display: 'flex',
    gap: theme.other.spacing._4,
  },

  marketCell: {
    width: 60,
    height: 50,
    borderRadius: theme.other.spacing._4,

    [theme.fn.largerThan('sm')]: {
      width: 100,
    },
  },

  footer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.other.spacing._16,

    [theme.fn.largerThan('sm')]: {
      display: 'none',
    },
  },

  footerLink: {
    height: 16,
    width: 100,
  },

  hideOnMobile: {
    [theme.fn.smallerThan('md')]: {
      display: 'none',
    },
  },
}));
